import { Badge } from '@zyxantech/tux'
import { ProtocolBadge } from '@zyxantech/wiz'
import { gatewayProtocol } from '../gateway.utils'

/**
 * Renders the wiz ProtocolBadge when the gateway's protocolConfig names a known
 * protocol, otherwise falls back to a neutral tux Badge with the raw label.
 */
export function ProtocolTag({ protocolConfig }: { protocolConfig: unknown }) {
  const protocol = gatewayProtocol(protocolConfig)
  if (protocol) return <ProtocolBadge protocol={protocol} />

  const raw =
    typeof protocolConfig === 'object' && protocolConfig !== null
      ? (protocolConfig as Record<string, unknown>).protocol
      : null
  return <Badge variant="default">{typeof raw === 'string' ? raw : 'Unknown'}</Badge>
}
